// firebase.js
import { initializeApp, getApps } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCxEEK1PKL_10tXODRm3sxJj7hq-GRTcLE",
  authDomain: "objetos-club.firebaseapp.com",
  projectId: "objetos-club",
  storageBucket: "objetos-club.firebasestorage.app",
  messagingSenderId: "299400653272",
  appId: "1:299400653272:web:eef91b0bc00f3c9ee36aad",
  measurementId: "G-SFFGF6C9B3",
};

// Evitar inicializar dos veces
const app = !getApps().length ? initializeApp(firebaseConfig) : getApps()[0];
const analytics = getAnalytics(app);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
